/**
 * EyesOnOff sticky ATC — IntersectionObserver + Impulse variant sync.
 * Does not modify theme.js. Easy to disable via Theme Editor setting.
 */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 769px)');

  function initStickyAtc(bar) {
    if (!bar || bar.dataset.eooInit === 'true') return;
    bar.dataset.eooInit = 'true';

    var section = bar.closest('[data-section-type="product"]');
    if (!section) return;

    var mainBtn = section.querySelector('[data-add-to-cart]');
    var mainText = section.querySelector('[data-add-to-cart-text]');
    var mainPrice = section.querySelector('[data-product-price]');
    var stickyBtn = bar.querySelector('[data-eoo-sticky-atc-button]');
    var stickyText = bar.querySelector('[data-eoo-sticky-atc-text]');
    var stickyPrice = bar.querySelector('[data-eoo-sticky-price]');
    var mobileOnly = bar.getAttribute('data-mobile-only') === 'true';

    if (!mainBtn || !stickyBtn) return;

    function isMobileContext() {
      return !mobileOnly || MOBILE_MQ.matches;
    }

    function syncFromMain() {
      if (stickyText && mainText) {
        stickyText.textContent = mainText.textContent.trim();
      }
      stickyBtn.disabled = mainBtn.disabled;
      if (stickyPrice && mainPrice) {
        stickyPrice.textContent = mainPrice.textContent.trim();
      }
    }

    function setVisible(visible) {
      if (!isMobileContext()) {
        bar.hidden = true;
        document.body.classList.remove('eoo-sticky-atc-active');
        return;
      }
      bar.hidden = !visible;
      document.body.classList.toggle('eoo-sticky-atc-active', visible);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting);
        });
      },
      { root: null, threshold: 0, rootMargin: '0px' }
    );

    observer.observe(mainBtn);

    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      mainBtn.click();
    });

    section.addEventListener('variantChange', syncFromMain);
    section.addEventListener('variantPriceChange', syncFromMain);

    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(syncFromMain);
      mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
      if (mainText) {
        mo.observe(mainText, { childList: true, characterData: true, subtree: true });
      }
      if (mainPrice) {
        mo.observe(mainPrice, { childList: true, characterData: true, subtree: true });
      }
    }

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', function () {
        if (!isMobileContext()) {
          setVisible(false);
        } else if (mainBtn.getBoundingClientRect().bottom < 0 || mainBtn.getBoundingClientRect().top > window.innerHeight) {
          setVisible(true);
        }
      });
    }

    syncFromMain();
  }

  function boot() {
    document.querySelectorAll('[data-eoo-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
